export default "__VITE_ASSET__COCoTV3I__"